import {stringToDashed} from 'cl-automation-utils';
import {addDynamicDialog} from 'crazyEditor/redux/modules/panel/panel';
import BillingPeriodSwitch from 'PricingWidget/BillingPeriodSwitch/BillingPeriodSwitch';
import WrongPlanDialog from 'PricingWidget/WrongPlanDialog';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import _ from 'lodash';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import * as Colors from 'material-ui/styles/colors';
import InlineButton from 'shared/components/InlineButton';
import LineWithHelp from 'shared/components/LineWithHelp/LineWithHelp';
import {PlanAndBilling} from 'MyAccount/AccountPage/AccountPageSectionsData';
import CouponBox from './CouponBox/CouponBox';
import Header from './Header/Header';
import SelectPlan from './SelectPlan/SelectPlan';
import {couponTypes} from './helpers/getCouponType';
import ChildrenFader from 'shared/components/ChildrenFader';
import ToggleButtonGroup, {BUTTONS_TYPES} from '../shared/components/ToggleButtonGroup';
import TooltipWrapper from '../shared/components/TooltipWrapper';
import {
  CHANGE_PLAN_DIALOG_NAME,
  CHANGE_TYPE_PLAN,
  BILLING_PERIOD,
  CHANGE_TYPE_BILLING_PERIOD,
  NEW_PLANS_GENERATION,
  getPrice,
  INVENTORY_SYNC,
  FOOTER_REMOVAL,
  BACKGROUND_REMOVAL,
  getPriceText,
} from 'MyAccount/AccountPage/PlanAndBilling/Consts';
import Icon from '@material-ui/core/Icon';
import {StickyContainer} from 'react-sticky';
import Sticky from '../shared/components/Sticky/Sticky';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import muiTheme from 'cl-layout/theme';
import {useDispatch, useSelector} from 'react-redux';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const sassStyle = require('./styles.scss');

const theme = createMuiTheme(muiTheme);

const styles = {
  base: {
    colors: Colors.grey200,
    backgroundColor: Colors.grey50,
  },
  active: {
    backgroundColor: '#ED6D23',
    color: '#fff',
  },
  btn: {
    margin: '0 0 30px 0',
    height: 50,
  },
  btnLabel: {
    padding: '0 40px',
  },
};

const PERIOD = {
  month: 'Month',
  annual: 'Year',
  twoYears: 'Two Years',
};

const PayPalUrl = '/application/user/test-paypal-one';

const LETS_TALK = "Let's talk";

export default class PricingWidget extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showLimitReachedModal: false,
      busy: false,
      selectedBillingPeriod: props.billingPeriod || BILLING_PERIOD.YEAR,
      inventorySyncAddOn: props.inventorySync,
      footerRemovalAddOn: props.footerRemoval,
      backgroundRemovalAddOn: props.backgroundRemoval,
    };
  }

  componentWillMount() {
    const {integrated} = this.props;
    if (!integrated) {
      this.changePlanDialog = require('MyAccount/AccountPage/PlanAndBilling/ChangePlanDialog');
    }
    this.backToPlans(true); // clear selected plan when switching between custom and standard plans
  }

  componentDidMount() {
    const {location} = this.props;
    const upgraded = typeof location.query.UpgradedSuccessfully !== 'undefined';
    if (upgraded) {
      setTimeout(() => {
        this.context.router.replace({
          pathname: PlanAndBilling.route,
          query: {},
        });
      }, 300);
    }
  }

  getPremiumPlanMessage = (activeListingsLimit, planName) => {
    const listingsAmount = activeListingsLimit !== '0' ? 'up to ' + activeListingsLimit : this.getUnlimitedPlanText();
    return (
      'Hi CrazyLister,\n' +
      'My business of ' +
      listingsAmount +
      ' listings deserves the best!\n' +
      'Can you tell me more about the ' +
      planName +
      ' Plan?'
    );
  };

  getUnlimitedPlanText = (uniqueListingsLimitPlans = null) => {
    if (!uniqueListingsLimitPlans) {
      const {plans} = this.props;
      uniqueListingsLimitPlans = _.uniqBy(plans, 'activeListingsLimit');
    }
    return uniqueListingsLimitPlans[1].activeListingsLimit + ' +';
  };

  getPriceBlock(plan, currency, couponData) {
    const {userPlanId, billingPeriod, isPaymentActive, integrated, openChat} = this.props;
    const {selectedBillingPeriod} = this.state;
    if (plan.activeListingsLimit === null) {
      if (integrated) {
        const {
          location: {
            query: {activeListingsLimit = '100'},
          },
        } = this.props;
        return (
          <InlineButton
            className={`${sassStyle.price} cla-lets-talk`}
            label={LETS_TALK}
            style={{color: plan.isPreferred ? Colors.white : Colors.lightGreen700}}
            onClick={() => openChat(this.getPremiumPlanMessage(activeListingsLimit, plan.name))}
          />
        );
      }
      return <span className={sassStyle.price}>{LETS_TALK}</span>;
    }
    const discountPercent = couponData ? couponData.discountPercent / 100 : 0;
    const annualPrice = Number(plan.annualPrice);
    let addOnsTotalPrice = _.sum(_.map(this.getCheckedAddOnsData(), ({price}) => price));
    if (isPaymentActive && billingPeriod === BILLING_PERIOD.YEAR) {
      addOnsTotalPrice /= 12;
    }
    const calcPrice = (price, round = false) => {
      const total = price * (1 - discountPercent);
      return round ? this.roundHalfDown(total) : total;
    };
    let price;
    let subPriceDiv;
    let couponGreen;

    let billingPeriodString = 'Billed annually';
    price = annualPrice;
    if (isPaymentActive) {
      if (billingPeriod === BILLING_PERIOD.MONTH && userPlanId === plan.id) {
        price = Number(plan.price);
        billingPeriodString = 'Billed monthly';
      }
    } else if (selectedBillingPeriod === BILLING_PERIOD.MONTH) {
      price = Number(plan.price);
      billingPeriodString = 'Billed monthly';
    }

    switch (couponData && couponData.type) {
      case couponTypes.DISCOUNT_MONTHS: {
        subPriceDiv = [
          <div key="sub_price_div_1" className={`${sassStyle.couponGreen} cla-price-1`}>
            for first {couponData.durationInMonth === 1 ? 'month' : `${couponData.durationInMonth} months`}
          </div>,
          <div key="sub_price_div_2" className={`${sassStyle.greyPrice} cla-price-2`}>
            and then {currency}
            {price} / month
          </div>,
        ];
        price = calcPrice(price, true);
        couponGreen = true;
        break;
      }
      case couponTypes.FREE_MONTHS: {
        price = annualPrice;
        subPriceDiv = (
          <div className={sassStyle.couponGreen}>
            First {couponData.durationInMonth === 1 ? 'month' : `${couponData.durationInMonth} months`} - Free
          </div>
        );
        break;
      }
      case couponTypes.LIFETIME: {
        subPriceDiv = (
          <div className={`${sassStyle.greyPrice} ${sassStyle.accent}`}>
            Regular price:{' '}
            <span className={`${sassStyle.incorrect} cla-price`}>
              {currency}
              {price}
            </span>
          </div>
        );
        price = calcPrice(price, true);
        couponGreen = true;
        break;
      }
      default:
        break;
    }

    return (
      <span>
        <span className={couponGreen ? sassStyle.couponGreen : undefined}>
          {currency}
          <span className={`${sassStyle.price} cla-price`}>{price + addOnsTotalPrice}</span> / mo
          <br />
          <span style={{fontSize: 16, opacity: 0.6, fontWeight: 300}}>{billingPeriodString}</span>
        </span>
        <div className={sassStyle.subPriceText}>{subPriceDiv}</div>
      </span>
    );
  }

  getAddOnsData() {
    const {paidFeaturesData, billingPeriod} = this.props;
    const {inventorySyncAddOn, footerRemovalAddOn, backgroundRemovalAddOn} = this.state;
    const checkboxBillingPeriod = billingPeriod || BILLING_PERIOD.MONTH;
    const getNameWithPrice = name => `${name}: ${getPriceText(name, paidFeaturesData, checkboxBillingPeriod)}`;
    const addOns = {
      [INVENTORY_SYNC]: {
        checked: inventorySyncAddOn,
        value: 'inventorySyncAddOn',
      },

      [FOOTER_REMOVAL]: {
        checked: footerRemovalAddOn,
        value: 'footerRemovalAddOn',
      },
    };
    _.forEach(addOns, (addOn, name) => {
      addOns[name] = {...addOn, nameAndPrice: getNameWithPrice(name), price: getPrice(name, paidFeaturesData)};
    });
    return addOns;
  }

  getCheckedAddOnsData = () => _.pickBy(this.getAddOnsData(), ({checked}) => !!checked);

  roundHalfDown = price => {
    if ((price * 2) % 1 === 0) {
      return Math.floor(price);
    }
    return Math.round(price);
  };

  hideModal = () => {
    this.setState({showLimitReachedModal: false});
  };

  chosePlan(plans, id) {
    const {location, integrated, isPaymentActive} = this.props;
    const {query, pathname} = location;
    this.setState({busy: true});
    if (!integrated) {
      if (!isPaymentActive) {
        this.context.router.push({
          pathname,
          query: Object.assign({}, query, {plan: id}),
        });
      } else {
        this.context.router.push({
          pathname,
          query: {...query, openDialog: CHANGE_PLAN_DIALOG_NAME, changeType: CHANGE_TYPE_PLAN, toPlanId: id},
        });
      }
    } else {
      const signupBlock = document.getElementById('Signup');
      if (signupBlock && window.TweenMax) {
        window.TweenMax.to(window, 1.2, {
          ease: window.Power2.easeInOut,
          scrollTo: signupBlock.getBoundingClientRect().top,
        });
      }
    }
    this.setState({busy: false});
  }

  pickPlan(plans, id, period, bonuses) {
    const {track, activeListingsCount, couponStatus, paidFeaturesData} = this.props;
    const plan = this.findPlanById(plans, id);
    if (track) {
      track('Upgrade Clicked');
    }
    if (!(plan.activeListingsLimit === null) && activeListingsCount >= plan.activeListingsLimit) {
      this.setState({
        showLimitReachedModal: true,
        numOfListingsAllowed: plan.activeListingsLimit,
      });
    } else {
      const coupon = couponStatus.coupon;
      const addOns = !bonuses
        ? _.map(this.getCheckedAddOnsData(), (addOnData, name) => paidFeaturesData[name].type)
        : undefined;
      let path = `${PayPalUrl}?planId=${plan.id}&period=${period}`;
      path += bonuses ? '&bonuses=true' : '';
      path += coupon ? '&promotion=' + coupon.code : '';
      path += addOns ? '&addOns=' + addOns : '';
      window.location = path;
    }
  }

  findPlanById(plans, id) {
    return plans[_.findIndex(plans, {id: Number(id)})];
  }

  backToPlans = (replace = false) => {
    const {location} = this.props;
    if (!location.query.plan) {
      return;
    }
    const router = this.context.router;
    const path = {
      pathname: location.pathname,
      query: Object.assign({}, location.query, {plan: undefined}),
    };
    if (replace) {
      router.replace(path);
    } else {
      router.push(path);
    }
  };

  handleBillingPeriodChange = selectedBillingPeriod => {
    this.setState({selectedBillingPeriod});
  };

  SelectPlanButton = ({plan}) => {
    const {
      integrated,
      openChat,
      location: {
        query: {activeListingsLimit = '100'},
      },
      plans,
    } = this.props;
    const {id, name} = plan;
    const isPremiumPlan = plan.activeListingsLimit === null;
    let label;
    let onClick;
    if (integrated) {
      return null;
    }
    const {activeListingsCount, connectedAccounts} = useSelector(
      ({user: {activeListingsCount}, accountPage: {accounts}}) => {
        const connectedAccounts = _.size(accounts);
        return {
          activeListingsCount,
          connectedAccounts,
        };
      }
    );
    const dispatch = useDispatch();
    if (isPremiumPlan) {
      label = 'Contact Us';
      onClick = () => openChat(this.getPremiumPlanMessage(activeListingsLimit, name));
    } else {
      label = 'Select plan';
      if (activeListingsLimit >= activeListingsCount && plan.eBayAccountsLimit >= connectedAccounts) {
        onClick = () => this.chosePlan(plans, id);
      } else {
        onClick = () =>
          dispatch(
            addDynamicDialog(WrongPlanDialog, {
              selectedPlan: plan.id,
              onContinueToPlan: planId => {
                this.chosePlan(plans, planId);
              },
              onTalkToUs: activeListingsCount => openChat(this.getPremiumPlanMessage(activeListingsCount, 'Premium')),
            })
          );
      }
    }
    return (
      <RaisedButton
        id={`cla-btn-${stringToDashed(label.toLowerCase())}-id-${plan.id}`}
        label={label}
        onClick={onClick}
        style={styles.btn}
        labelStyle={styles.btnLabel}
      />
    );
  };

  handleAddOnChange = name => event => {
    this.setState({[name]: event.target.checked});
  };

  renderChangeBillingPeriodButton(isPreferred) {
    const {location, switchToAnnualSave} = this.props;
    const {pathname, query} = location;

    return (
      <InlineButton
        onClick={() => {
          this.context.router.push({
            pathname,
            query: {
              ...query,
              openDialog: CHANGE_PLAN_DIALOG_NAME,
              changeType: CHANGE_TYPE_BILLING_PERIOD,
              toBillingPeriod: BILLING_PERIOD.YEAR,
            },
          });
        }}
        style={{color: isPreferred ? '#fff' : Colors.grey700}}
      >
        <span>
          <strong>Save ${switchToAnnualSave}</strong> by switching to annual billing
        </span>
      </InlineButton>
    );
  }

  renderBox(plans, plan, currency) {
    const {
      couponStatus,
      supportLiveEbayListings,
      userPlanId,
      isPaymentActive,
      openChat,
      billingPeriod,
      pricingGeneration,
    } = this.props;
    const SelectPlanButton = this.SelectPlanButton;
    const features = typeof plan.features === 'string' ? JSON.parse(plan.features) : plan.features;
    const priceBlock = this.getPriceBlock(plan, currency, couponStatus.coupon);
    const newWidget = pricingGeneration === NEW_PLANS_GENERATION;
    const topPlan = newWidget ? undefined : _.maxBy(plans, plan => Number(plan.price));
    const button = <SelectPlanButton plan={plan} />;
    const isPreferred = plan.isPreferred;
    const addOns = this.getCheckedAddOnsData();
    return (
      <Paper
        id={`cla-plan-${plan.id}`}
        key={plan.id}
        className={`${sassStyle.plan} ${isPreferred ? sassStyle.active : ''}`}
        style={isPreferred ? styles.active : styles.base}
      >
        <div className={sassStyle.title}>
          <div className={sassStyle.planHeader}>{plan.name}</div>
          <div className={sassStyle.subHeader}>{plan.tip}</div>
        </div>
        <div>
          <div className={`${sassStyle.priceSlide} ${sassStyle.active}`}>
            <div className={`${sassStyle.priceBlock} ${sassStyle.active}`}>{priceBlock}</div>
          </div>
        </div>
        {plan.id === userPlanId && isPaymentActive ? (
          <div id={`cla-current-plan-${plan.id}`} className={sassStyle.currentPlan}>
            <Icon
              style={{
                color: isPreferred ? Colors.white : Colors.lightGreen700,
                marginRight: 5,
                verticalAlign: 'text-bottom',
              }}
            >
              check_circle
            </Icon>
            <span>CURRENT PLAN</span>
            <div style={{marginTop: 10}}>
              {billingPeriod === BILLING_PERIOD.MONTH && this.renderChangeBillingPeriodButton(isPreferred)}
            </div>
          </div>
        ) : (
          button
        )}
        <ul className={sassStyle.featuresList}>
          {features.map((feature, index) => (
            <div key={'plan' + plan.id + '_feature' + index} style={{display: 'flex'}}>
              <Icon style={{position: 'relative', top: 4, right: 10}}>check</Icon>
              <LineWithHelp
                key={index}
                title={feature}
                supportLiveEbayListings={supportLiveEbayListings}
                iconColor={isPreferred ? '#fff' : Colors.grey600}
                toolTipStyle={{width: 200, whiteSpace: 'normal'}}
                className={sassStyle.featureHelp}
              />
            </div>
          ))}
          {!_.isEmpty(addOns) && (
            <div style={{paddingTop: 8}}>
              <strong>Add ons:</strong>
              {_.map(addOns, (addOnData, displayName) => (
                <li key={'bullet_' + displayName}>
                  <Icon style={{position: 'relative', top: 4, right: 10}}>check</Icon>
                  <span>{displayName}</span>
                </li>
              ))}
            </div>
          )}
          {topPlan && !!topPlan.activeListingsLimit && plan.id === topPlan.id && plans.length > 1 && (
            <li>
              Need more? <InlineButton onClick={() => openChat()}>Talk to us</InlineButton>
            </li>
          )}
        </ul>
      </Paper>
    );
  }

  renderActiveListingsLimitButtons() {
    const {location, plans, userPlanId, isPaymentActive} = this.props;
    const {pathname, query} = location;
    const activeListingsLimit = _.get(query, 'activeListingsLimit', '100');
    const buttons = [];
    const uniqueListingsLimitPlans = _.uniqBy(plans, 'activeListingsLimit');
    const currentPlan = this.findPlanById(plans, userPlanId);
    const unLimitedText = this.getUnlimitedPlanText();
    _.forEachRight(uniqueListingsLimitPlans, plan => {
      const current =
        isPaymentActive && currentPlan && currentPlan.activeListingsLimit === plan.activeListingsLimit
          ? ' (current)'
          : '';
      const planActiveListingsLimit = plan.activeListingsLimit ? plan.activeListingsLimit : 0;
      const label = (planActiveListingsLimit ? 'Up to ' + planActiveListingsLimit : unLimitedText) + current;
      const button = {
        label: label.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        onChange: () =>
          this.context.router.replace({
            pathname,
            query: {...query, activeListingsLimit: planActiveListingsLimit},
          }),
        checked: parseInt(activeListingsLimit, 10) === planActiveListingsLimit,
      };
      buttons.push(button);
    });
    return buttons;
  }

  render() {
    const {
      className,
      style,
      type,
      location,
      plans,
      premiumPlan,
      integrated,
      isPaymentActive,
      subTitle,
      couponStatus,
      supportLiveEbayListings,
      pricingGeneration,
    } = this.props;
    const newWidget = pricingGeneration === NEW_PLANS_GENERATION;
    const {
      query: {plan, promotion, UpgradedSuccessfully, activeListingsLimit = '100'},
    } = location;
    const {
      showLimitReachedModal,
      busy,
      numOfListingsAllowed,
      selectedBillingPeriod,
      inventorySyncAddOn,
      footerRemovalAddOn,
      backgroundRemovalAddOn,
    } = this.state;
    const currency = 'USD $';
    let planId = Number(plan);
    const showCoupon = typeof promotion !== 'undefined' && !integrated;
    const hasPlanId = typeof plan !== 'undefined';
    const upgraded = typeof UpgradedSuccessfully !== 'undefined';
    const wrongIdUrl = _.findIndex(plans, p => p.id === planId) === -1;
    if (!upgraded && hasPlanId && (isPaymentActive || wrongIdUrl)) {
      planId = undefined;
    }
    const currentPlan = this.findPlanById(plans, planId);
    const shownPlans = newWidget
      ? _.concat(
          _.orderBy(
            _.filter(
              plans,
              plan => (plan.activeListingsLimit ? plan.activeListingsLimit : 0) === parseInt(activeListingsLimit, 10)
            ),
            'name',
            ['desc']
          ),
          premiumPlan || []
        )
      : plans;
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const mobileView = screenWidth < 550;
    const StickyWrapper = mobileView && newWidget ? StickyContainer : 'div';

    return (
      <div className={`${className ? className : ''} ${sassStyle.pricingWidget}`} style={style}>
        <MuiThemeProvider theme={theme}>
          {!integrated && React.createElement(this.changePlanDialog)}
          <div className={sassStyle.wrap}>
            <div className={sassStyle.mergedHead}>
              {showCoupon && <CouponBox className={sassStyle.coupon} />}
              <div>
                <Header title="Simple Prices - No Surprises" subTitle={subTitle} className={sassStyle.widgetHeader} />
                {!isPaymentActive && !currentPlan ? (
                  <BillingPeriodSwitch
                    selectedBillingPeriod={selectedBillingPeriod}
                    onChange={this.handleBillingPeriodChange}
                  />
                ) : (
                  undefined
                )}
                {newWidget &&
                  !plan && [
                    <div
                      key="listings_amount"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        margin: mobileView ? 20 : '20px 0px',
                        flexDirection: mobileView ? 'column' : 'row',
                      }}
                    >
                      <div>Choose how many active listings you have:</div>
                      <TooltipWrapper
                        tooltipStyle={{textAlign: 'center'}}
                        popoverType="grey"
                        tooltip={
                          mobileView ? '' : 'The total amount of live listings you have across all of your accounts'
                        }
                      >
                        <InlineButton
                          target="_blank"
                          href={supportLiveEbayListings}
                          label="What are active listings?"
                        />
                      </TooltipWrapper>
                    </div>,
                    !mobileView && (
                      <ToggleButtonGroup
                        key="toggle_buttons"
                        variant={BUTTONS_TYPES.FLAT}
                        buttons={this.renderActiveListingsLimitButtons()}
                        color="secondary"
                        withArrow
                        largeButtons
                      />
                    ),
                  ]}
              </div>
            </div>
          </div>
          <div style={{paddingTop: 3}}>
            <ChildrenFader path={planId ? planId : ''}>
              {!currentPlan && (
                <StickyWrapper
                  className={`${sassStyle.wrap} ${sassStyle.planList}`}
                  style={{display: 'flex', flexDirection: 'column'}}
                >
                  {newWidget && !plan && mobileView && (
                    <Sticky
                      style={{width: screenWidth, position: 'relative', left: -35, overflowX: 'scroll'}}
                      fullWidth
                      id="toggle_buttons_sticky"
                    >
                      <ToggleButtonGroup
                        variant={BUTTONS_TYPES.FLAT}
                        buttons={this.renderActiveListingsLimitButtons()}
                        stickyHomePage
                        color="secondary"
                        largeButtons
                      />
                    </Sticky>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: mobileView ? 'column' : 'row',
                      justifyContent: shownPlans.length === 1 ? 'center' : undefined,
                    }}
                  >
                    {shownPlans.map(plan => this.renderBox(shownPlans, plan, currency))}
                  </div>
                  {!isPaymentActive && (
                    <Paper style={{marginTop: '16px'}}>
                      <div style={{padding: '16px', display: 'flex', flexDirection: 'column'}}>
                        <strong>Add ons</strong>
                        <FormGroup column>
                          {_.map(this.getAddOnsData(), ({checked, value, nameAndPrice}) => (
                            <FormControlLabel
                              control={
                                <Checkbox checked={checked} onChange={this.handleAddOnChange(value)} value={value} />
                              }
                              label={nameAndPrice}
                            />
                          ))}
                        </FormGroup>
                      </div>
                    </Paper>
                  )}
                </StickyWrapper>
              )}
              {currentPlan && (
                <SelectPlan
                  style={{display: 'flex'}}
                  className={sassStyle.selectPlan}
                  planId={String(planId)}
                  plan={currentPlan}
                  back={callback => this.backToPlans()}
                  couponStatus={couponStatus}
                  selectedBillingPeriod={selectedBillingPeriod}
                  pickPlan={(years, bonuses) => {
                    let period = '';
                    switch (years) {
                      case 1:
                        period = PERIOD.annual;
                        break;
                      case 2:
                        period = PERIOD.twoYears;
                        break;
                      default:
                        period = PERIOD.month;
                    }
                    this.pickPlan(plans, planId, period, bonuses);
                  }}
                  show2Year={type === 1}
                  showBonus
                  checkedAddOns={this.getCheckedAddOnsData()}
                />
              )}
            </ChildrenFader>
          </div>
          <Dialog
            open={showLimitReachedModal}
            contentStyle={{padding: 30, textAlign: 'center', width: '45%'}}
            onRequestClose={this.hideModal}
          >
            <div style={{fontSize: 26, paddingBottom: 20}}>Plan's listings limit reached</div>
            <p style={{fontSize: 16}}>
              You already have more than {numOfListingsAllowed}
              active listings. <br /> Please select a plan to fit your needs
            </p>
            <RaisedButton
              label="Sure, I'll pick another plan"
              primary
              onClick={this.hideModal}
              backgroundColor="#f27326"
            />
          </Dialog>
          {busy && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                cursor: 'wait',
                width: '100%',
                height: '100%',
                zIndex: 10000,
              }}
            />
          )}
        </MuiThemeProvider>
      </div>
    );
  }
}

PricingWidget.propTypes = {
  className: PropTypes.string,
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      isPreferred: PropTypes.bool,
      price: PropTypes.string,
    })
  ),
  supportLiveEbayListings: PropTypes.string,
  type: PropTypes.number,
  openChat: PropTypes.func,
  integrated: PropTypes.bool,
  isPaymentActive: PropTypes.bool,
  billingPeriod: PropTypes.number,
};

PricingWidget.defaultProps = {
  type: 4,
  showSwitch: true,
  subTitle: 'Priced just right for sellers of every size',
  integrated: false,
  userPlanId: -1,
  isPaymentActive: false,
  couponStatus: {},
};
